import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { TomoSection } from './TomoSection';
import { BeforeAfterSection } from './BeforeAfterSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FooterSection } from './FooterSection';
import { SocialProofPopup } from './SocialProofPopup';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-156">
      <HeroSection data-id="element-157" />
      <ProblemSection data-id="element-158" />
      <SolutionSection data-id="element-159" />
      <TomoSection data-id="element-160" />
      <BeforeAfterSection data-id="element-161" />
      <BonusSection data-id="element-162" />
      <PricingSection data-id="element-163" />
      <GuaranteeSection data-id="element-164" />
      <TestimonialsSection data-id="element-165" />
      <FAQSection data-id="element-166" />
      <FooterSection data-id="element-167" />
      <SocialProofPopup data-id="element-168" />
    </div>;
}